import { useEffect } from "react";

/**
 * Updates document <title>, meta description, OG and Twitter tags per page.
 * Pure client-side — works because Google now executes JS to read meta tags.
 */
export default function useDocumentMeta({ title, description, image, type = "website", keywords = [] } = {}) {
  useEffect(() => {
    const SITE = "House of Absolutes KA";
    const finalTitle = title ? (title.length > 55 ? title : `${title} — ${SITE}`) : `${SITE} — Buy Pure Floral Absolutes Online: Rose, Jasmine, Tuberose, Pink Lotus`;
    document.title = finalTitle;

    const set = (selector, attr, value) => {
      if (value == null) return;
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const m = selector.match(/\[(?:name|property)="([^"]+)"\]/);
        if (m) el.setAttribute(selector.includes("property=") ? "property" : "name", m[1]);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) set('meta[name="description"]', "content", description);
    if (keywords && keywords.length > 0) set('meta[name="keywords"]', "content", keywords.join(", "));
    set('meta[property="og:title"]', "content", finalTitle);
    set('meta[property="og:description"]', "content", description || "");
    set('meta[property="og:type"]', "content", type);
    set('meta[property="og:url"]', "content", window.location.href);
    if (image) set('meta[property="og:image"]', "content", image);
    set('meta[name="twitter:card"]', "content", image ? "summary_large_image" : "summary");
    set('meta[name="twitter:url"]', "content", window.location.href);
    set('meta[name="twitter:title"]', "content", finalTitle);
    set('meta[name="twitter:description"]', "content", description || "");
    if (image) set('meta[name="twitter:image"]', "content", image);
    if (image) set('meta[property="og:image:alt"]', "content", finalTitle);

    // Canonical
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", window.location.href.split("?")[0].split("#")[0]);
  }, [title, description, image, type, keywords]);
}

export function injectJsonLd(id, data) {
  if (typeof window === "undefined") return;
  const old = document.getElementById(id);
  if (old) old.remove();
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = id;
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
}
